import { push } from "connected-react-router";
import { cloneDeep, isNil } from "lodash";
import { generate } from "short-uuid";
import { appStore } from "index";
import { ConditionalVisibility } from "store/current-dashboard/types";
export const pushIfNeeded = (dispatch, selectedSectionIndex, pathSectionId, pathInformations) => {
    const designerSectionid = appStore?.getState()?.designer?.present?.analysis?.sections?.[selectedSectionIndex]?.id;
    if (designerSectionid && designerSectionid !== pathSectionId) {
        let newPath = pathInformations.join("/").replace(pathSectionId, designerSectionid);
        newPath = newPath.endsWith(designerSectionid) ? newPath : `${newPath}/${designerSectionid}`;
        dispatch(push(newPath));
    }
};
export const moveUp = (index, array) => {
    if (array?.[0] && index > 0) {
        const [itemToMove] = array.splice(index, 1);
        array.splice(index - 1, 0, itemToMove);
    }
};
export const moveDown = (index, array) => {
    if (array?.[index + 1]) {
        const [itemToMove] = array.splice(index, 1);
        array.splice(index + 1, 0, itemToMove);
    }
};
export const arrayRemove = (index, array) => {
    if ((index || index === 0) && array?.[index]) {
        array.splice(index, 1);
    }
};
const generateOrReplace = (widgetIdRecord, id) => {
    if (!widgetIdRecord[id]) {
        widgetIdRecord[id] = generate();
    }
    return widgetIdRecord[id];
};
const replaceId = (widgetIdRecord, compProps) => {
    const newCompProps = cloneDeep(compProps);
    if (newCompProps?.parentId) {
        newCompProps.parentId = generateOrReplace(widgetIdRecord, newCompProps.parentId);
    }
    if (newCompProps?.childrenId) {
        newCompProps.childrenId = generateOrReplace(widgetIdRecord, newCompProps.childrenId);
    }
    if (newCompProps?.default) {
        newCompProps.default = generateOrReplace(widgetIdRecord, newCompProps.default);
    }
    if (newCompProps?.widgets) {
        newCompProps.widgets = newCompProps.widgets.map((value) => generateOrReplace(widgetIdRecord, value));
    }
    return newCompProps;
};
export const createSectionFrom = (source, sourceWidgets) => {
    const newWidgets = [];
    const newWidgetLayout = { all: [] };
    const widgetIdRecord = {};
    Object.keys(source?.widgets || []).forEach((key) => {
        if (sourceWidgets && source?.widgets) {
            source?.widgets[key].forEach((w) => {
                let widgetId = w.id;
                if (w.id && sourceWidgets?.[w.id]) {
                    if (!widgetIdRecord[w.id]) {
                        widgetId = generate();
                        widgetIdRecord[w.id] = widgetId;
                    }
                    widgetId = widgetIdRecord[w.id];
                    newWidgets.push({ ...sourceWidgets?.[w.id || ""]?.componentName ? sourceWidgets?.[w.id || ""] : sourceWidgets?.[(sourceWidgets?.[w.id || ""]).parentId],
                        componentProps: replaceId(widgetIdRecord, (sourceWidgets?.[w.id || ""]).parentId && !sourceWidgets?.[w.id || ""].componentProps
                            ? sourceWidgets?.[(sourceWidgets?.[w.id || ""]).parentId].componentProps
                            : sourceWidgets?.[w.id || ""].componentProps),
                        id: widgetIdRecord[w.id],
                        metadata: { editableWidget: (sourceWidgets?.[w.id || ""]).metaData?.editableWidget ||
                                (sourceWidgets?.[w.id || ""]).metadata?.editableWidget } });
                }
                if (newWidgetLayout[key]) {
                    newWidgetLayout[key].push({ ...w, id: widgetId });
                }
                else {
                    newWidgetLayout[key] = [{ ...w, id: widgetId }];
                }
            });
        }
    });
    return { section: { ...source,
            id: generate(),
            name: source?.name ? `${source.name} (Copy)` : "New Section",
            widgets: newWidgetLayout },
        widgets: newWidgets };
};
export const createOrUpdateDesignerSection = (source) => {
    if (!source) {
        return createSectionFrom();
    }
    return { section: source };
};
export const getSectionToEdit = (state, sectionId) => {
    const currentSectionIndex = state?.analysis?.sections?.findIndex((s) => s.id === sectionId) ?? -1;
    const { section: editedSection } = createOrUpdateDesignerSection(state.sections?.[sectionId]);
    if (state.sections && state.analysis?.sections?.[currentSectionIndex]) {
        state.analysis.sections[currentSectionIndex].id = editedSection.id;
    }
    if (state.sections && editedSection.id) {
        state.sections[editedSection.id] = editedSection;
    }
    return { currentSectionIndex, editedSection: state.sections?.[editedSection.id ?? -1] || {} };
};
export const updateLayout = (layout, newLayout) => {
    layout.height = newLayout.h;
    layout.width = newLayout.w;
    layout.positionX = newLayout.x;
    layout.positionY = newLayout.y;
};
export const updateSectionWidgets = (editedSection, conditionalVisibility, widgetId, action) => {
    const conditionalVisibilityIndex = editedSection.widgets?.[ConditionalVisibility[conditionalVisibility]]?.findIndex((w) => w.id === widgetId);
    const allIndex = editedSection.widgets?.all?.findIndex((w) => w.id === widgetId);
    if (!isNil(conditionalVisibilityIndex) && editedSection.widgets?.[ConditionalVisibility[conditionalVisibility]] &&
        editedSection.widgets?.[ConditionalVisibility[conditionalVisibility]].length > 0 &&
        (allIndex === -1 || isNil(allIndex) || conditionalVisibilityIndex !== -1)) {
        action(editedSection.widgets?.[ConditionalVisibility[conditionalVisibility]], conditionalVisibilityIndex, ConditionalVisibility[conditionalVisibility]);
        return;
    }
    if (!isNil(allIndex) && editedSection.widgets?.all) {
        action(editedSection.widgets?.all, allIndex, "all");
    }
};
export const changeSelectionOfSelectProps = (dataSelectedProps, selectedValues) => {
    const dataprops = cloneDeep(dataSelectedProps);
    Object.entries(selectedValues || {}).forEach(([key, value]) => {
        const index = Number(key);
        const previousSelectedValueKey = Object.keys(dataprops[index].selectValues)
            .find((pkey) => dataprops[index].selectValues[pkey].defaultValue);
        dataprops[index].selectValues[value] = { ...dataprops[index].selectValues[value],
            defaultValue: true };
        if (previousSelectedValueKey && previousSelectedValueKey !== value) {
            dataprops[index].selectValues[previousSelectedValueKey] = { ...dataprops[index].selectValues[previousSelectedValueKey],
                defaultValue: false };
        }
    });
    return dataprops || [];
};
export const updateAnalysisSection = (section, analysis, currentSectionIndex) => {
    if (analysis && section && (currentSectionIndex === 0 || currentSectionIndex)) {
        analysis[currentSectionIndex] = {
            id: section.id,
            name: section.name
        };
    }
};
export const mapWidgetMetadataForSection = (widgets) => {
    if (widgets) {
        Object.keys(widgets).forEach((key) => {
            const widget = widgets[key];
            widget.metadata = {
                ...widget.metadata,
                ...widget.metaData
            };
        });
    }
};
